<template>
    <div>
        <action-bar>
        </action-bar>
        <main class="content">
            <div>
                <h1>Themenschwerpunkt erstellen</h1>
                <div class="form-group">
                    <label for="input_name">Name</label>
                    <input type="text" class="form-control" v-model="name" id="input_name">
                </div>
                <button class="btn btn-primary" @click="save">Erstellen</button>
            </div>
        </main>
    </div>
</template>
<script>
export default {
  data() {
    return {
      name: ""
    };
  },
  methods: {
    save() {
      let form = new FormData();
      form.append("create_key_theme[name]", this.name);
      form.set("create_key_theme[submit]", null);
      axios
        .post("/api/" + store.state.language + "/key_theme/create", form)
        .then(({ data }) => {
          this.$router.push({
            name: "key-theme-edit",
            params: { keyThemeId: data.result.id }
          });
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/key_theme/Create.vue